<template>
    <div class="docer-wrapper">
        <user-frame
            :isLogin="isLogin"
            :discount="discount"
            ref="userframe">
        </user-frame>

        <div class="docer-content">
            <navbar
                :nav="nav"
                :tabs="tabs"
                :isLogin="isLogin"
                v-on:navbar_link="pageRouter"
                v-on:navbar_refresh="pageRefresh"
                ref="navbar">

                <in-search
                    ref="insearch"
                    v-on:insearch="tmplSearch">
                </in-search>
            </navbar>
            <div
                id="frame_wrapper"
                v-bind:style="{ height: innerHeight, minHeight: '500px' }">

                <templates
                    v-show="nav === 'Templates'"
                    v-if="asyncLoad.Templates && !maintenance"
                    ref="templates">
                </templates>

                <maintenance
                    v-show="nav === 'Templates'"
                    v-if="maintenance">
                </maintenance>

                <vip-introduce 
                    :isLogin="isLogin"
                    :discount="discount"
                    v-show="nav === 'WPS Premium'">
                </vip-introduce>

            </div>
        </div>

        <!-- <discount-alert :discount="discount"></discount-alert> -->
    </div>
</template>

<script>
import Util from '../../assets/js/util.js';
import Conf from '../../config/index.js';
import UserFrame from './UserFrame.vue';
import Navbar from './Navbar.vue';
import InSearch from '../common/InSearch.vue';
import VipIntroduce from  '../templates/VipIntroduce.vue';
import DiscountAlert from '../discount/DiscountAlert.vue';
import Maintenance from '../templates/Maintenance.vue';

const Templates = () => import('../templates/Templates.vue');
export default {
    name: 'app',

    data: () => ({
        nav: 'Templates',

        tabs: ['Templates','WPS Premium'],

        asyncLoad: {
            Recommend: false,
            Templates: false
        },

        isLogin: false,

        innerHeight: Util.setHeight(60),

        discount: Conf.discount,

        maintenance: Conf.maintenance
    }),

    components: {
        UserFrame,
        Navbar,
        InSearch,
        Templates,
        VipIntroduce,
        DiscountAlert,
        Maintenance,
    },

    created() {
        let _this = this;
        let hasShow = false;
        let pageLoad = function () {
            if (hasShow) { return; }

            hasShow = true;
            setTimeout(function () {
                _this.asyncLoad[_this.nav] = true;
            }, 200);
        };
        this.discount.shouldShow = this.discount.state && this.discount.channelids.indexOf(AppInfo.disnum) >= 0;
        this.discount = { ...this.discount };
        // 注册登录/注销事件
        window.VEvts.$on('LOGIN_CHANGE', function (value) {
            _this.isLogin = false;
            setTimeout(() => {
                _this.isLogin = value.isLogin;
                if (!value.isLogin) {
                    _this.$store.commit('change_vip_status', false);
                }
            }, 10);
        });
        this.checkNewType();
        // 检测登录状态
        this.userCheckLogin();
        this.checkUwp();
        this.isPaid();
        pageLoad();
    },

    mounted() {
        let _this = this;
        let timer = 0;

        window.addEventListener('resize', function () {
            clearTimeout(timer);
            timer = setTimeout(function () {
                _this.innerHeight = Util.setHeight(60);
                _this.$refs.userframe.getRectFiles();
                _this.$refs.recommend && _this.$refs.recommend.getReflow();
            }, 600);
        }, false);

        Util.jsAsynCall('GetLoadStartedTime', true)
            .then(function(res) {
                Util.gaReport('send', 'timing', '/loadstart', 'load', new Date() - res.result);
            })
            .catch(function(err) {
                try {
                    Util.gaReport('send', 'timing', '/loadstart', 'load', new Date() - window.homepageapi.GetLoadStartedTime());
                } catch(err) {
                    console.log('client has not this method: GetLoadStartedTime');
                }
            });
    },

    methods: {
        pageRouter(data) {
            this.nav = data;
            !this.asyncLoad[data] && (this.asyncLoad[data] = true);

            if (data === 'Recommend') {
                this.$refs.recommend && this.$refs.recommend.getReflow();
            }
            Util.gaReport('send', 'event', '/navbar/navlink', 'click', data);
            return this;
        },

        pageRefresh() {
            let _this = this;
            let nav = this.nav;

            _this.asyncLoad[nav] = false;
            setTimeout(function () {
                _this.asyncLoad[nav] = true;
            }, 200);

            Util.gaReport('send', 'event', '/navbar/refresh', 'click');
            return this;
        },

        tmplMore() {
            let _this = this;

            this.$refs.navbar.navLink('Templates');
            setTimeout(function () {
                _this.$refs.templates.pageTask('tmplMore');
            }, 200);

            Util.gaReport('send', 'event', '/recommend/templates', 'more');
            return this;
        },

        tmplPreview(data) {
            let _this = this;

            this.$refs.navbar.navLink('Templates');
            setTimeout(function () {
                _this.$refs.templates.pageTask('tmplPreview', data);
            }, 200);

            Util.gaReport('send', 'event', '/recommend/templates', 'click', data.name);
            return this;
        },

        tmplSearch(data) {
            let _this = this;

            this.$refs.navbar.navLink('Templates');
            setTimeout(function () {
                _this.$refs.templates.pageTask('tmplSearch', data);
            }, 200);

            Util.gaReport('send', 'event', '/navbar/searchtemplates', 'search', data);
            return this;
        },

        isPaid() {
            let _this = this;
            // 主要检测license用户
            Util.jsAsynCall('isPaid', true)
                .then(function(res) {
                    if (res.result == '1') {
                        Util.Cookie.create('wps_paid', 1, undefined, '.wps.com');
                        _this.discount.shouldShow = false;
                        _this.discount = { ..._this.discount };
                    } else {
                        Util.Cookie.create('wps_paid', null, -10000000, '.wps.com');
                    }
                    VEvts.$emit('WPSPAID_STATUS_CHANGE');
                })
                .catch(function(err) {
                    console.log('check paid error');
                });
        },

        userCheckLogin() {
            let _this = this;
            Util.jsAsynCall('qingCheckLogined', true)
                .then(function (res) {
                    let [errorCode, isLogin, wpsKey, userInfo] = eval('(' + res.result + ')');

                    // 登录并且获取用户信息
                    if (isLogin == 'true') {
                        _this.isLogin = true;
                    }
                })
                .catch(function() {
                    _this.isLogin = false;
                });
        },

        checkUwp() {
            let isUwp = !!window.AppInfo.isUwp;
            this.$store.commit('change_uwp_status', isUwp);
        },

        checkNewType() {
            console.log('checkNewType', this.$route.query.type);
            switch (this.$route.query.type) {
                case 'wps':
                    this.$store.commit('set_new_type', 'WORD');
                    break;
                case 'et':
                    this.$store.commit('set_new_type', 'EXCEL');
                    break;
                case 'wpp':
                    this.$store.commit('set_new_type', 'PPT');
                    break;
                default:
                    break;
            }
        }
    }
}
</script>

<style lang="less">
@import '../../assets/styles/common.css';
@import '../../assets/styles/docer_skin.less';

.docer-wrapper,
.docer-content {
    position: relative;
    width: auto;
    height: 100%;
}

.docer-content {
    font-size: 12px;
    overflow-y: hidden;
    background: #f7f7f7;
}

#frame_wrapper {
    position: relative;
}
</style>



// WEBPACK FOOTER //
// App.vue?0f048510